import React from "react";
import { TableCell } from "@mui/material";

interface SortableTableHeaderCellProps {
  columnName: string;
  sortArrow: string;
  width: string | number;
  onClick?: () => void;
  backgroundColor?: string;
  style?: React.CSSProperties;
}

export const SortableTableHeaderCell: React.FC<
  SortableTableHeaderCellProps
> = ({
  columnName,
  sortArrow,
  width,
  onClick,
  backgroundColor = "inherit",
  style: additionalStyle,
}) => {
  return (
    <TableCell
      onClick={onClick}
      style={{
        fontSize: 14,
        fontWeight: 600,
        cursor: onClick ? "pointer" : "default",
        verticalAlign: "bottom",
        width: width,
        backgroundColor: backgroundColor,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        position: "sticky",
        top: 0,
        zIndex: 1,
        paddingLeft: sortArrow ? "20px" : "12px",
        paddingRight: "12px",
        paddingTop: "12px",
        paddingBottom: "12px",
        borderRight: "1px solid #e0e0e0",
        borderBottom: "2px solid #e0e0e0",
        ...additionalStyle,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          minWidth: 0,
        }}
      >
        {sortArrow && (
          <span
            style={{
              marginRight: "4px",
              flexShrink: 0,
              fontSize: "8px",
              lineHeight: 1,
            }}
          >
            {sortArrow}
          </span>
        )}
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
        >
          {columnName}
        </span>
      </div>
    </TableCell>
  );
};
